module.exports = __webpack_public_path__ + "static/media/icon-insights-assistant.5487a144.svg";